module.exports = __webpack_public_path__ + "30b694d74f73c15856532fed9b45233b.jpg";